import moment from "moment";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ApproveModal from "../../../components/modals/approveModal";
import { customerApproveReject } from "../../../redux/actions/customerActions";
import "../../products/productDetail.css";

const SubscribeTableData = ({ data, index, currentPage }) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    if (status === "pending") {
      return "text-warning";
    } else if (status === "rejected") {
      return "text-danger";
    }
    return orderStatus?.find((e) => e?.status === status)?.color;
  };

  return (
    <tr className="table-rows1" key={index}>
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">{data.code ?? "--"}</td>
      <td className="table-each-row-data">{data?.pharmacy_name ?? "--"}</td>
      <td className="table-each-row-data">{data?.mobile ?? "--"}</td>
      <td className="table-each-row-data">
        <span className={`${getStatusColor(data.approval)} text-capitalize`}>
          {data.approval}
        </span>
      </td>
      <td className="table-each-row-data">
        {data?.is_basic_details === false
          ? "Profile Completion Pending"
          : data?.is_contact_details === false
          ? "Contact Details Pending"
          : data?.is_mci_certificate === false
          ? "MCI Certificate Pending"
          : data?.onboardingFieldforce.approval === "pending"
          ? "Field Force Approval Pending"
          : data?.onboardingFieldforce.approval === "rejected"
          ? "Field Force Approval Rejected"
          : "--"}
      </td>
      <td className="table-each-row-data">
        {moment(data?.updatedAt).format("DD MMM YYYY, HH:mm A")}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(`/customers/onboarding-pharmacy/view/${data?.id}`)
            }
          >
            {"view"}
          </button>
        </div>
      </td>
    </tr>
  );
};

export default SubscribeTableData;

export const orderStatus = [
  { status: "acknowledged", value: "Acknowledged", color: "ack_status" },
  {
    status: "partially_acknowledged",
    value: "Partially Acknowledged",
    color: "color_2ad3e7 ",
  },
  { status: "fully_invoiced", value: "Fully Invoiced", color: "text_green" },
  {
    status: "partially_invoiced",
    value: "Partial Invoiced",
    color: "Medium_Purple",
  },
  { status: "pending", value: "Approval Pending", color: "Medium_Purple" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "rejected", value: "Rejected", color: "text-danger" },
  { status: "hold", value: "Under Process", color: "text-warning" },
];
